// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".layersIcon{stroke:var(--primary-text-color);fill:var(--primary-text-color)}", "",{"version":3,"sources":["webpack://./../shared/icons/LayersIcon.scss"],"names":[],"mappings":"AAAA,YACE,gCAAA,CACA,8BAAA","sourcesContent":[".layersIcon {\n  stroke: var(--primary-text-color);\n  fill: var(--primary-text-color);\n}"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
